export default __webpack_public_path__ + "static/media/(5).d98a66c0.jpg";